// external dependencies
import React from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'

// constants
import { MIN_HEIGHTS, MQ } from 'utils/styleHelpers'

const BackgroundImg = styled.div`
	background-repeat: no-repeat;
	background-image: url(${({ heroImageSm }) => heroImageSm});
	background-color: #0c3d5a; // fallback color
	background-position: ${({ heroImagePositionSm }) => heroImagePositionSm};
	min-height: ${MIN_HEIGHTS.XS};
	width: 100%;

	${MQ.S} {
		background-image: url(${({ heroImageMd }) => heroImageMd});
		background-position: ${({ heroImagePositionMd }) => heroImagePositionMd};
		min-height: ${MIN_HEIGHTS.SM};
	}

	${MQ.M} {
		background-image: url(${({ heroImageLg }) => heroImageLg});
		background-position: ${({ heroImagePositionLg }) => heroImagePositionLg};
		min-height: ${MIN_HEIGHTS.M};
	}

	${MQ.L} {
		background-image: url(${({ heroImageXl }) => heroImageXl});
		background-position: ${({ heroImagePositionXl }) => heroImagePositionXl};
		min-height: ${MIN_HEIGHTS.M};
	}

	// To ensure image is centered for screens larger than Xl img size of 2560
	@media screen and (min-width: 2560px) {
		background-position: 50% 50%;
	}
`

const BackgroundImage = ({
	heroImageSm,
	heroImagePositionSm,
	heroImageMd,
	heroImagePositionMd,
	heroImageLg,
	heroImagePositionLg,
	heroImageXl,
	heroImagePositionXl,
}) => (
	<BackgroundImg
		heroImageSm={heroImageSm}
		heroImagePositionSm={heroImagePositionSm}
		heroImageMd={heroImageMd}
		heroImagePositionMd={heroImagePositionMd}
		heroImageLg={heroImageLg}
		heroImagePositionLg={heroImagePositionLg}
		heroImageXl={heroImageXl}
		heroImagePositionXl={heroImagePositionXl}
	/>
)

BackgroundImage.defaultProps = {
	heroImagePositionSm: '100% 90%',
	heroImagePositionMd: '40% 0%',
	heroImagePositionLg: '30% 0%',
	heroImagePositionXl: '50% 0%',
}

BackgroundImage.propTypes = {
	heroImageSm: string.isRequired,
	heroImagePositionSm: string,
	heroImageMd: string.isRequired,
	heroImagePositionMd: string,
	heroImageLg: string.isRequired,
	heroImagePositionLg: string,
	heroImageXl: string.isRequired,
	heroImagePositionXl: string,
}

export default BackgroundImage
